module.exports = __webpack_public_path__ + "img/sumt.6b9ba76f.png";